export default __webpack_public_path__ + "static/media/14.8bb27a6e.png";